var generateStyle = function generateStyle(componentTheme) {
  return {
    blankSpace: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: componentTheme.blankHeight,
      minWidth: componentTheme.blankMinWidth,
      verticalAlign: 'middle',
      border: "1px solid ".concat(componentTheme.blankBorderColor),
      borderRadius: componentTheme.blankBorderRadius,
      padding: '2px 2px'
    }
  };
};
export default generateStyle;